import { computed } from 'vue'
import { ACCESS } from '@/lib/accessCodes'
import { useAuthStore } from '@/ContextTab/stores/auth/auth'
import type { TaskPanelNewsSetType } from '@/lib/types'


export function useAccess() {

  const authStore = useAuthStore()

  const userId = computed(() => authStore.userId)

  const getUserPermissions = computed(
    () => authStore.tokenData?.permissions ?? [],
  )

  const allowedTaskPanels = computed<TaskPanelNewsSetType[]>(() =>
    [
      ...(userHasAllPermissions([ACCESS.NEWS.INCOMING]) ? ['waiting' as TaskPanelNewsSetType] : []),
      ...(userHasAllPermissions([ACCESS.NEWS.IN_WORK]) ? ['inProgress' as TaskPanelNewsSetType] : []),
      ...(userHasAllPermissions([ACCESS.NEWS.USER]) ? ['my' as TaskPanelNewsSetType] : []),
    ],
  )

  function isSuperUserPermissions(permissionCodes: string[]) {
    // на эти коды права суперпользователя не распространяются
    const extraAccessCodes = [
      ACCESS.NEWS.GROUPMATES_NEWS,
      ACCESS.NEWS.EMBARGO_MGT,
      ACCESS.NEWS.REVOKE,
    ]
    return (
      getUserPermissions.value.includes(ACCESS.ADMIN.SUPERUSER)
      && permissionCodes.every((code) => !extraAccessCodes.includes(code))
    )
  }

  function userHasAllPermissions(permissionCodes: string[]) {
    return (
      Boolean(getUserPermissions.value)
      && permissionCodes.reduce((acc, value) => {
        if (isSuperUserPermissions(permissionCodes)) {
          return true
        }

        if (!acc) {
          return false
        }

        return getUserPermissions.value.includes(String(value))
      }, true)
    )
  }

  function userHasAnyPermission(permissionCodes: string[]) {
    return (
      Boolean(getUserPermissions.value)
      && permissionCodes.reduce((acc, value) => {
        if (isSuperUserPermissions(permissionCodes)) {
          return true
        }

        if (acc) {
          return true
        }

        return getUserPermissions.value.includes(String(value))
      }, false)
    )
  }

  return {
    userId,
    getUserPermissions,
    userHasAllPermissions,
    userHasAnyPermission,
    allowedTaskPanels,
  }
}
